import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { BroadcastTags_queryKey } from './constants';
import { updateBroadcastTag } from '../../../api/appSettings.service';

type MutationFnArgs = {
  id: string;
  name: string;
};

export const useUpdateBroadcastTagQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ id, name }: MutationFnArgs) => {
      setLoading();

      return updateBroadcastTag(id, { name });
    },
    onSuccess: () => {
      toast.success('Broadcast tag has been updated successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [BroadcastTags_queryKey] });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
